import { GroupIds } from "@/configuration/group-ids";
import {
  type SchedulingCustomerConfig,
  SchedulingSmsAvailabilityStrategy,
  SchedulingSmsEligibilityStrategy,
} from "@/customer-interface/scheduling";

/** Live Voice also requires the backend rollout switch and agent opt-in. SMS remains sandbox-only. */
export const entpartnersSchedulingConfig = {
  appointmentQuery: {
    enabledGroupIds: { VOICE: [GroupIds.ENT_PARTNERS_LIVE_SANDBOX] },
  },
  locationQuery: {
    enabledGroupIds: {
      SMS: [GroupIds.ENT_PARTNERS_LIVE_SANDBOX],
      VOICE: [GroupIds.ENT_PARTNERS_LIVE_SANDBOX],
    },
  },
  policy: {
    scheduleConfigPath: "configuration/groups/entpartners/rules/schedule.yaml",
  },
  voice: {
    workflow: "deterministic",
    workflowEnabledGroupIds: [GroupIds.ENT_PARTNERS_LIVE_SANDBOX, GroupIds.ENT_PARTNERS_LIVE],
    cancellation: "direct",
    optionSearch: {
      progressiveChronologicalWindows: true,
      progressivePolicyRankedWindows: false,
      progressiveLinkedUnitWindows: false,
    },
  },
  // SMS appointment reads and live SMS retain their current paths.
  sms: {
    eligibility: SchedulingSmsEligibilityStrategy.Agentic,
    eligibilityEnabledGroupIds: [GroupIds.ENT_PARTNERS_LIVE_SANDBOX],
    availability: SchedulingSmsAvailabilityStrategy.AgenticProvider,
    availabilityEnabledGroupIds: [GroupIds.ENT_PARTNERS_LIVE_SANDBOX],
    bookingEnabledGroupIds: [GroupIds.ENT_PARTNERS_LIVE_SANDBOX],
  },
} as const satisfies SchedulingCustomerConfig;
